import { useTranslation } from 'react-i18next'

import { createErrorBlocker, FlowExecuteOnce } from '@cash-web/shared-blocker-feature-main'

export const JourneyDefaultError = () => {
  const { t } = useTranslation()
  return (
    <FlowExecuteOnce
      onExecute={flow =>
        flow.startWithBlockerDescriptors({
          trackingFlowName: 'Default Error',
          blockerDescriptors: [{ blocker: { form: createErrorBlocker(t) } }],
          queriesToInvalidate: [],
        })
      }
    />
  )
}
